export default [
    "24 24",
    '<path d="M15 18L9 12L15 6" fill="none" class="stroke-over" stroke="var(--ci-primary-color, currentColor)"  stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>']